export const DEFAULT_COLORS = [
  { id: 'primary', label: 'Primary', value: '#667eea' },
  { id: 'secondary', label: 'Secondary', value: '#764ba2' },
  { id: 'text', label: 'Text', value: '#333333' },
  { id: 'text-secondary', label: 'Text Secondary', value: '#666666' },
  { id: 'accent', label: 'Accent', value: '#28a745' },
  { id: 'background', label: 'Background', value: '#ffffff' },
  { id: 'surface', label: 'Surface', value: '#f8f9fa' },
  { id: 'border', label: 'Border', value: '#e0e0e0' },
]

export const CUSTOM_COLOR_SLOTS = 4

export function buildColorCssVars(colors) {
  return colors.map(c => `  --eb-color-${c.id}: ${c.value};`).join('\n')
}

export function getColorSwatches(colors) {
  return colors.map(c => c.value)
}
